<template>
    <div>
        <v-text-field
            v-model="item"
            :label="label"
            :readonly="readonly"
            outlined
            :type="type"
            :min="min"
            :max="max"
            :color="color ? color : inputColor"
            :background-color="color ? `${color} lighten-5` : backgroundColor"
            :clearable="!(readonly || notClearable)"
            dense
            :disabled="disabled"
            :hint="hint"
            :persistent-hint="persistentHint"
            :placeholder="placeholder"
            :autofocus="autoFocus"
            :step="step"
            :suffix="suffix"
            :prefix="prefix"
            :append-icon="appendIcon"
            :append-outer-icon="appendOuterIcon"
            :prepend-inner-icon="prependInnerIcon"
            @click:append-outer="clickAppendOuter"
            hide-details="auto"
            :rules="rules"
            @input="input"
            @focus="focus"
            @blur="blur"
        ></v-text-field>
        
        <input type="hidden"/>
    </div>
</template>

<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref, watch} from "vue";

export default {
    props: {
        value: [Number, String],
        label: String,
        color: String,
        disabled: Boolean,
        autoFocus: Boolean,
        readonly: Boolean,
        notClearable: Boolean,
        rules: Array,
        type: String,
        min: String,
        max: String,
        hint: String,
        persistentHint: Boolean,
        placeholder: String,
        step: String,
        suffix: String,
        prefix: String,
        prependInnerIcon: String,
        appendOuterIcon: String,
        appendIcon: String
    },
    emits: ["input", "blur", "focus", "clickAppendOuter"],
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        
        const item = ref(null);
        
        watch(() => props.value, () => {
            item.value = props.value;
        });
        
        onMounted(() => {
            if (props.value !== null && props.value !== undefined)
                item.value = props.value;
        });
        
        function input(value) {
            emit("input", value);
        }
        
        function focus() {
            emit("focus");
        }
        
        function blur() {
            emit("blur");
        }
        
        function clickAppendOuter() {
            emit("clickAppendOuter");
        }
        
        return {
            loading,
            inputColor,
            backgroundColor,
            item,
            input,
            focus,
            blur,
            clickAppendOuter
        };
    }
};
</script>